<template>
  <div class="card">
    <div class="card-body">
      <h2>Settings</h2>
      <div class="email-change">
        <h4 class="mt-5">Change Your Email</h4>
        <div class="row">
          <div class="col-md-4 offset-md-4">
            <input type="text" class="form-control" v-model="email">
            <p class="text-success mt-3" v-if="email_message">{{ email_message }}</p>
            <p class="text-danger mt-3" v-if="email_error">{{ email_error }}</p>
            <button class="btn btn-primary my-3" @click="submitChangeEmail">Change Email</button>
          </div>
        </div>
      </div>
      <div class="password-change">
        <h4 class="mt-5">Change Password</h4>
        <div class="row">
          <div class="col-md-4">
            <label for="">Current Password</label>
            <input class="form-control" type="password" autocomplete="current-password" v-model="current_password">
          </div>
          <div class="col-md-4">
            <label for="">New Password</label>
            <input class="form-control" type="password" autocomplete="new-password" v-model="new_password">
          </div>
          <div class="col-md-4">
            <label for="">Confirm New Password</label>
            <input class="form-control" type="password" autocomplete="new-password" v-model="confirm_password">
          </div>
        </div>
        <p class="text-success mt-3" v-if="password_message">{{ password_message }}</p>
        <p class="text-danger mt-3" v-if="password_error">{{ password_error }}</p>
        <button class="btn btn-primary my-3" @click="submitChangePassword">Change Password</button>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/services/userService'

export default {
  name: 'Settings',
  data () {
    return {
      email: '',
      email_message: '',
      email_error: '',
      current_password: '',
      new_password: '',
      confirm_password: '',
      password_message: '',
      password_error: ''
    }
  },
  created () {
    userService.getSettings().then(data => {
      this.email = data.user.email
    })
  },
  methods: {
    submitChangeEmail () {
      // TODO: put this in vuex
      this.email_error = ''
      this.email_message = ''
      userService.changeSettings({
        email: this.email
      }).then(data => {
        this.email_message = data.message
        this.$store.dispatch('users/setUser', data.user)
      }).catch(error => {
        this.email_error = error.response.data.error
      })
    },
    submitChangePassword () {
      this.password_error = ''
      this.password_message = ''
      userService.changePassword({
        current_password: this.current_password,
        new_password: this.new_password,
        confirm_password: this.confirm_password
      }).then(data => {
        this.password_message = data.message
      }).catch(error => {
        this.password_error = error.response.data.error
      }).then(() => {
        this.current_password = ''
        this.new_password = ''
        this.confirm_password = ''
      })
    }
  }
}
</script>
